import { render } from "./UserInfoForm.vue?vue&type=template&id=fbcdf0b2&scoped=true"
import script from "./UserInfoForm.vue?vue&type=script&lang=js"
export * from "./UserInfoForm.vue?vue&type=script&lang=js"

import "./UserInfoForm.vue?vue&type=style&index=0&id=fbcdf0b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbcdf0b2"]])

export default __exports__